package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSpxValue
import org.jetbrains.compose.web.dom.Div

@Composable
fun Height(height: CSSLengthOrPercentageNumericValue) {
    Div(
        Modifier.height(height).toAttrs()
    )
}

@Composable
fun Width(width: CSSpxValue) {
    Div(Modifier.width(width).toAttrs())
}